export default __webpack_public_path__ + "static/media/1.243ee793.jpg";